import {
  FALLBACK_DISCOUNT_CODE_PRICE,
  STARTER_KIT_PRICE,
} from "@/lib/utils/common/constants";

export const modalIds = {
  ogDiscount: "og_discount",
  ngDiscount: "ng_discount",
  androidAnnouncement: "android_announcement",
  notifyMe: "notify_me",
  osSelection: "os_selection",
  phoneCategory: "phone_category",
  phoneModel: "phone_model",
  quiz: "quiz",
  quizQuestionnaire: "quiz_questionnaire",
  quizExit: "quiz_exit",
};

export const discountImages = {
  ng: "https://cdn.inito.com/inito_website/home/assets/discount/ng_popup.jpg",
  og: "https://cdn.inito.com/inito_website/home/og_discount.webp",
};
export const saleImages = {
  ng: "https://cdn.inito.com/inito_website/home/ng_sale.webp",
  og: "https://cdn.inito.com/inito_website/home/og_sale.webp",
  ngMobile: "https://cdn.inito.com/inito_website/home/assets/discount/discount_modal_mobile_3.png",
  ngDesktop: "https://cdn.inito.com/inito_website/home/assets/discount/discount_modal_desktop_3.png",
};
export const salePricing = {
  ng: {
    old: STARTER_KIT_PRICE.ng,
    new: STARTER_KIT_PRICE.ng - FALLBACK_DISCOUNT_CODE_PRICE.ng,
  },
  og: { old: 149, new: 89 },
};
